// extracted by mini-css-extract-plugin
module.exports = {"header":"PlasmicMyEvalsHeader_header__ogREq","logo":"PlasmicMyEvalsHeader_logo__ZfY3I"};